import { ActionFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import { submitMutation } from '~/api/data/responses';
import {
  AddServiceRequestCommentDocument,
  AddServiceRequestCommentMutation,
  AddServiceRequestCommentMutationVariables,
  ResolveServiceRequestDocument,
  ResolveServiceRequestMutation,
  ResolveServiceRequestMutationVariables,
  UpdateServiceRequestDocument,
  UpdateServiceRequestMutation,
  UpdateServiceRequestMutationVariables
} from '~/api/graphql';

export const resolveServiceRequest = (variables: ResolveServiceRequestMutationVariables) =>
  mutateData<ResolveServiceRequestMutation, ResolveServiceRequestMutationVariables>(client, {
    mutation: ResolveServiceRequestDocument,
    variables
  });

export const updateServiceRequest = (variables: UpdateServiceRequestMutationVariables) =>
  mutateData<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>(client, {
    mutation: UpdateServiceRequestDocument,
    variables
  });

export const addServiceRequestComment = (variables: AddServiceRequestCommentMutationVariables) =>
  mutateData<AddServiceRequestCommentMutation, AddServiceRequestCommentMutationVariables>(client, {
    mutation: AddServiceRequestCommentDocument,
    variables
  });

export const submitResolveServiceRequest: ActionFunction = async ({ params, request }) => {
  const formData = await request.formData();
  return submitMutation(
    resolveServiceRequest({
      id: params.id || '',
      input: {
        notes: formData.get('notes') as string,
        files: formData.getAll('files') as File[]
      }
    })
  );
};

export const submitUpdateServiceRequest: ActionFunction = async ({ params, request }) => {
  return submitMutation(updateServiceRequest({ id: params.id || '', input: await request.json() }));
};

export const submitAddServiceRequestComment: ActionFunction = async ({ params, request }) => {
  return submitMutation(
    addServiceRequestComment({ id: params.id || '', input: await request.json() })
  );
};
